exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payments-method-options[data-v-268e7ff0]{display:flex;align-items:center;gap:10px;padding-top:10px}input[type=radio][data-v-268e7ff0]{display:none}input[type=radio]+label[data-v-268e7ff0]{border:1px solid #ddd;display:inline-flex;padding:10px;cursor:pointer;width:100px;height:64px;align-items:center;justify-content:center}input[type=radio]+label img[data-v-268e7ff0]{display:block;-o-object-fit:contain;object-fit:contain;height:100%;width:100%}input[type=radio]:checked+label[data-v-268e7ff0]{border-color:#ba1913}small[data-v-268e7ff0]{display:block;font-size:10px}", ""]);

// exports
